import { Tooltip } from '@base-ui/react/tooltip'
import { TOOLTIP_DELAY } from './trigger'
import type { PartProps } from '../../../lib/part-props'

interface TooltipProviderProps extends PartProps<Tooltip.Provider.Props> {}

/** Shares one delay across its tooltips, so moving between neighbours opens the next one instantly. */
function TooltipProvider({ delay = TOOLTIP_DELAY, ...props }: TooltipProviderProps) {
  return <Tooltip.Provider delay={delay} {...props} />
}

export { TooltipProvider }
